import { useState } from 'react';
import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import {useNavigate} from 'react-router-dom';
import imgLogo from './Portal_SUPPLIER_PORTAL_PWC.png';
import rightLogo from './right_bar.jpg';
import { useAuth } from 'oidc-react';

function Home() {

 const auth = useAuth();

  const[dataDrp, setDrpName] = useState({
    Level1DropDownVal:"",
    Level2DropDownVal:""
  });
  const navigate = useNavigate();
  
  let Level2DropDownVals;
  const Level1DropDownVal =['-- Select --','#10291 Scrap Form','More to come..'];
  const scrapEvalLevel2 = ['-- Select --','1. New Scrap Evaluation', '2. Confirm Mutilation'];

  const Level2DropDownVal =['-- Select --'];
  Level2DropDownVals = Level2DropDownVal.map((Level2DropDownVal,key)=> <option key={key} value={Level2DropDownVal}>{Level2DropDownVal}</option>)

  
  if(dataDrp.Level1DropDownVal==="#10291 Scrap Form"){
    Level2DropDownVals = scrapEvalLevel2.map((scrapEvalLevel2,key)=> <option key={key} value={scrapEvalLevel2}>{scrapEvalLevel2}</option>)
     }
     const Level1DropDownVals = Level1DropDownVal.map((Level1DropDownVal,key)=> <option key={key} value={Level1DropDownVal}>{Level1DropDownVal}</option>)
     function handleLevel1DrpChange(e){       
      setDrpName({...dataDrp,Level1DropDownVal:e.target.value});   
     }

     function handleLevel2DrpChange(e){    
      setDrpName({...dataDrp,Level2DropDownVal:e.target.value});            
    }

  const handleSubmit = async (event) => {    
    event.preventDefault();
    if(dataDrp.Level2DropDownVal !== "" && dataDrp.Level1DropDownVal !=="")
    {
      const isSubmitConfirm=window.confirm('Are you sure you want to submit this request?');
      if(isSubmitConfirm)
      {
        event.preventDefault();    
        if(dataDrp.Level2DropDownVal==="1. New Scrap Evaluation"){
          navigate('/NewScrapEvaluation');
        }
        if(dataDrp.Level2DropDownVal==="2. Confirm Mutilation"){
          navigate('/ConfirmMutilation');
        }
      }
    }else{
      alert("Please make sure both Application Name and Level#2 fields are selected");
    }    
  }

  
  const onClickCancelHandler=async(event)=>{  
    const isConfirmedCancel=window.confirm('You might loose the data, Are you sure you want to Cancel this request?');
    if(isConfirmedCancel)
    {
      setDrpName({...dataDrp,Level1DropDownVal:"-- Select --"}); 
      setDrpName({...dataDrp,Level2DropDownVal:"-- Select --"});  
    } 
    
  }
 // auth && auth.userData
  if (auth && auth.userData) {
  return (        
    <form onSubmit={handleSubmit}>     
    <div class="container">    
    <div class="row">
    <div class="col-8 p-0">
  <img src={imgLogo} alt="Logo" width="100%" height="80%"/>
</div>
<div class="col-4 p-0">
  <img src={rightLogo} alt="Logo" width="100%" height="80%"/>
</div>
</div>
<div class="row">
      
      <p style={{color:"#333"}}>This application is used for Online Forms. Please select a form and a level#2 step to continue.</p><br></br>
      <p style={{color:"#333"}}>For technical or accessibility issues, please contact P&WC Help Desk: (450) 647-3824</p><br></br>
      </div> 
  <div class="row">
    <div class="col-2">
      <label for="fname">Application Name <p style={{color:"red",float:"right"}}>*</p></label>
    </div>
    <div class="col-10">
    <select id="Level1" name="Level1" value={dataDrp.Level1DropDownVal} onChange={handleLevel1DrpChange} required>
                   {Level1DropDownVals}
                 </select>
    </div>
  </div>
  <div class="row">
    <div class="col-2">
      <label for="lname">Level#2 <p style={{color:"red",float:"right"}}>*</p></label>
    </div>
    <div class="col-10">
    <select id="Level2" name="Level2" value={dataDrp.Level2DropDownVal} onChange={handleLevel2DrpChange} required>
                   {Level2DropDownVals}
                 </select>
    </div>
  </div> 

  <div class="row">
    <div class="col-5">
    <input type="submit" value="Submit" /> &nbsp;   
    <input type="button" value="Cancel" onClick={onClickCancelHandler}/>
    </div>
  </div> 
</div>
    </form>
  )
  }else{
    return <div>Not logged in! Try to refresh to be redirected to login page.</div>;
  }

}

export default Home;
